import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // Increased to 60 seconds to handle slow MongoDB Atlas queries
});

export const volleyballApi = {
  // Get all championships
  getChampionships: async () => {
    try {
      const response = await api.get('/api/championships');
      return response.data;
    } catch (error) {
      console.error('Error fetching championships:', error);
      throw error;
    }
  },

  // Get a specific championship
  getChampionship: async (championshipId) => {
    try {
      const response = await api.get(`/api/championships/${championshipId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching championship ${championshipId}:`, error);
      throw error;
    }
  },

  // Get all matches for a championship
  getChampionshipMatches: async (championshipId) => {
    try {
      const response = await api.get(`/api/championships/${championshipId}/matches`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching matches for championship ${championshipId}:`, error);
      throw error;
    }
  },

  // Get matches for a specific round in a championship
  getChampionshipMatchesByRound: async (championshipId, round) => {
    try {
      const response = await api.get(`/api/championships/${championshipId}/matches/round/${round}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching matches for championship ${championshipId} round ${round}:`, error);
      throw error;
    }
  },

  // Get standings for a championship
  getChampionshipStandings: async (championshipId) => {
    try {
      const response = await api.get(`/api/championships/${championshipId}/standings`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching standings for championship ${championshipId}:`, error);
      throw error;
    }
  },

  // Get match detail
  getMatchDetail: async (matchId) => {
    try {
      const response = await api.get(`/api/matches/${matchId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching match ${matchId}:`, error);
      throw error;
    }
  },

  // Trigger manual update for all championships
  triggerUpdate: async () => {
    try {
      const response = await api.post('/api/update');
      return response.data;
    } catch (error) {
      console.error('Error triggering update:', error);
      throw error;
    }
  },

  // Trigger manual update for a specific championship
  triggerChampionshipUpdate: async (championshipId) => {
    try {
      const response = await api.post(`/api/championships/${championshipId}/update`);
      return response.data;
    } catch (error) {
      console.error(`Error triggering update for championship ${championshipId}:`, error);
      throw error;
    }
  },

  // Search for a team across all championships
  searchTeam: async (searchTerm) => {
    try {
      const response = await api.get('/api/search-team', {
        params: { q: searchTerm }
      });
      return response.data;
    } catch (error) {
      console.error('Error searching team:', error);
      throw error;
    }
  },

  // User Favorites API
  getUserFavorites: async (fingerprintId) => {
    try {
      const response = await api.get(`/api/favorites/${fingerprintId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user favorites:', error);
      throw error;
    }
  },

  syncUserFavorites: async (fingerprintId, favoriteChampionships) => {
    try {
      const response = await api.post('/api/favorites/sync', {
        fingerprintId,
        favoriteChampionships
      });
      return response.data;
    } catch (error) {
      console.error('Error syncing user favorites:', error);
      throw error;
    }
  },

  // Admin functions - now public (no authentication required)
  updateChampionships: async (championshipIds) => {
    try {
      const response = await api.post('/api/update-championships', { championshipIds });
      return response.data;
    } catch (error) {
      console.error('Error updating championships:', error);
      throw error;
    }
  },

  updateAllChampionships: async () => {
    try {
      const response = await api.post('/api/update-all-championships');
      return response.data;
    } catch (error) {
      console.error('Error updating all championships:', error);
      throw error;
    }
  },
};

export default volleyballApi;
